import { motion } from 'framer-motion';
import {
  ClipboardText,
  MagnifyingGlass,
  PencilLine,
  Rocket,
} from '@phosphor-icons/react';

const STEPS = [
  {
    icon: ClipboardText,
    title: 'لقاء استكشافي',
    text: 'نفهم احتياج المنشأة ونحدد نطاق العمل المناسب.',
  },
  {
    icon: MagnifyingGlass,
    title: 'قراءة وتشخيص',
    text: 'نجمع البيانات من الميدان والملفات لقياس الواقع الحالي.',
  },
  {
    icon: PencilLine,
    title: 'تصميم الحلول',
    text: 'نبني توصيات وخطط تنفيذ قابلة للتطبيق بأولويات واضحة.',
  },
  {
    icon: Rocket,
    title: 'مرافقة التطبيق',
    text: 'نتابع التنفيذ ونقيس الأثر لضمان الاستدامة.',
  },
];

const HowWeWorkSection = () => (
  <section
    data-testid="how-we-work-section"
    className="py-20 bg-[#FAFAF7]"
    dir="rtl"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <span className="inline-block px-4 py-1.5 rounded-full border border-[#D8D2C8] text-[#5D6E55] text-xs sm:text-sm mb-4">
          منهجيتنا
        </span>
        <h2 className="font-['Noto_Kufi_Arabic'] font-black text-[#1F3D2B] text-3xl sm:text-4xl md:text-5xl leading-[1.15] tracking-tight mb-4">
          كيف نعمل معك
        </h2>
        <p className="text-[#6B7565] max-w-2xl mx-auto leading-8">
          منهجية واضحة في أربع خطوات تضمن نتائج قابلة للتطبيق والاستدامة.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              className="bg-white rounded-[20px] border border-[#E6E0D6] p-6 relative"
            >
              <div className="absolute top-4 left-4 text-7xl font-bold text-[#F5F2EC] leading-none select-none">
                {String(i + 1).padStart(2, '0')}
              </div>
              <div className="relative">
                <div className="w-12 h-12 rounded-2xl bg-[#1F3D2B] flex items-center justify-center mb-4">
                  <Icon size={22} weight="duotone" className="text-white" />
                </div>
                <h3 className="font-bold text-[#1F3D2B] mb-2 font-['IBM_Plex_Sans_Arabic']">
                  {s.title}
                </h3>
                <p className="text-sm text-[#6B7565] leading-7">{s.text}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default HowWeWorkSection;
